const GOOGLE_ADS_LOGO =
  'https://res.cloudinary.com/dwx3u2p1d/image/authenticated/s--spKSKKfl--/v1756814219/zfvplloyzom48wlaochj.svg'
const META_ADS_LOGO =
  'https://res.cloudinary.com/dwx3u2p1d/image/authenticated/s--UUnWo7oI--/v1756814220/cozb65dpza70ipuvetzj.svg'
const SEO_LOGO =
  'https://res.cloudinary.com/dwx3u2p1d/image/authenticated/s--HWHUhgnS--/v1756814220/paw3jfyof6lmrhnvgq4f.svg'

export type TemplateCategory = 'google-ads' | 'meta-ads' | 'seo'

export type TemplateListItem = {
  id: string
  title: string
  description: string
  logo: string
  message: string
  agent: string
  category: TemplateCategory
}

export const templatesList: TemplateListItem[] = [
  {
    id: 'google-ads-pmax-creator',
    title: 'Google Ads: PMax Campaign Creator',
    description:
      'Create Performance Max campaigns with images from upload, Google Drive, or Sprites Designer.',
    logo: GOOGLE_ADS_LOGO,
    message: 'Create a Performance Max campaign for me',
    agent: 'google_ads',
    category: 'google-ads',
  },
  {
    id: 'google-ads-search-creator',
    title: 'Google Ads: Search Campaign Creator',
    description:
      'Build Search campaigns with your keywords, CSV imports, or AI-powered keyword research.',
    logo: GOOGLE_ADS_LOGO,
    message: 'Create a Google Ads Search campaign for me',
    agent: 'google_ads',
    category: 'google-ads',
  },
  {
    id: 'meta-ads-leads-instant-form-creator',
    title: 'Meta Ads: Leads Campaign Creator - Instant Form',
    description: 'Create lead generation campaigns using Facebook Instant Forms.',
    logo: META_ADS_LOGO,
    message: 'Create a Meta Ads lead generation campaign with Instant Forms',
    agent: 'meta_ads',
    category: 'meta-ads',
  },
  {
    id: 'meta-ads-sales-website-creator',
    title: 'Meta Ads: Sales Campaign Creator - Website',
    description: 'Create sales campaigns optimized for website conversions.',
    logo: META_ADS_LOGO,
    message: 'Create a Meta Ads sales campaign optimized for website conversions',
    agent: 'meta_ads',
    category: 'meta-ads',
  },
  {
    id: 'meta-ads-web-traffic-creator',
    title: 'Meta Ads: Web Traffic Campaign Creator',
    description: 'Create campaigns optimized for driving traffic to your website.',
    logo: META_ADS_LOGO,
    message: 'Create a Meta Ads campaign to drive traffic to my website',
    agent: 'meta_ads',
    category: 'meta-ads',
  },
  {
    id: 'google-ads-analyzer',
    title: 'Google Ads: Analyzer',
    description: 'Analyze campaign performance with deep insights and actionable recommendations.',
    logo: GOOGLE_ADS_LOGO,
    message: 'Analyze my Google Ads account',
    agent: 'google_ads',
    category: 'google-ads',
  },
  {
    id: 'meta-ads-analyzer',
    title: 'Meta Ads: Analyzer',
    description:
      'Analyze ad accounts, campaigns, and performance with infrastructure insights and intelligence.',
    logo: META_ADS_LOGO,
    message: 'Analyze my Meta Ads account',
    agent: 'meta_ads',
    category: 'meta-ads',
  },
  {
    id: 'google-ads-keywords-researcher',
    title: 'Google Ads: Keywords Researcher',
    description: 'Discover high-performing keywords with AI-powered research and suggestions.',
    logo: GOOGLE_ADS_LOGO,
    message: 'Research keywords for my Google Ads campaigns',
    agent: 'google_ads',
    category: 'google-ads',
  },
  {
    id: 'meta-ads-audience-builder',
    title: 'Meta Ads: Audience Builder',
    description: 'Create lookalike audiences and find interests for precise targeting.',
    logo: META_ADS_LOGO,
    message: 'Create a lookalike audience for my Meta Ads campaigns',
    agent: 'meta_ads',
    category: 'meta-ads',
  },
  {
    id: 'meta-ads-leads-website-creator',
    title: 'Meta Ads: Leads Campaign Creator - Website',
    description: 'Create lead generation campaigns driving to your website.',
    logo: META_ADS_LOGO,
    message: 'Create a Meta Ads lead generation campaign driving to my website',
    agent: 'meta_ads',
    category: 'meta-ads',
  },
  {
    id: 'meta-ads-leads-calls-creator',
    title: 'Meta Ads: Leads Campaign Creator - Calls',
    description: 'Create campaigns optimized for generating phone call leads.',
    logo: META_ADS_LOGO,
    message: 'Create a Meta Ads campaign optimized for generating phone call leads',
    agent: 'meta_ads',
    category: 'meta-ads',
  },
  {
    id: 'meta-ads-sales-app-creator',
    title: 'Meta Ads: Sales Campaign Creator - App Promo',
    description: 'Create sales campaigns for app promotion and installs.',
    logo: META_ADS_LOGO,
    message: 'Create a Meta Ads sales campaign for app promotion',
    agent: 'meta_ads',
    category: 'meta-ads',
  },
  {
    id: 'meta-ads-sales-call-creator',
    title: 'Meta Ads: Sales Campaign Creator - Call',
    description: 'Create sales campaigns optimized for phone call conversions.',
    logo: META_ADS_LOGO,
    message: 'Create a Meta Ads sales campaign optimized for phone call conversions',
    agent: 'meta_ads',
    category: 'meta-ads',
  },
  {
    id: 'meta-ads-sales-message-creator',
    title: 'Meta Ads: Sales Campaign Creator - Message',
    description: 'Create sales campaigns optimized for message conversions.',
    logo: META_ADS_LOGO,
    message: 'Create a Meta Ads sales campaign optimized for message conversions',
    agent: 'meta_ads',
    category: 'meta-ads',
  },
  {
    id: 'meta-ads-leads-instagram-creator',
    title: 'Meta Ads: Leads Campaign Creator - Instagram Message',
    description: 'Create lead generation campaigns via Instagram direct messages.',
    logo: META_ADS_LOGO,
    message: 'Create a Meta Ads lead generation campaign via Instagram direct messages',
    agent: 'meta_ads',
    category: 'meta-ads',
  },
  {
    id: 'google-ads-campaign-duplicator',
    title: 'Google Ads: Campaign Duplicator',
    description: 'Clone and modify existing campaigns to quickly launch new variations.',
    logo: GOOGLE_ADS_LOGO,
    message: 'Duplicate and modify my existing Google Ads campaign',
    agent: 'google_ads',
    category: 'google-ads',
  },
  {
    id: 'meta-ads-campaign-duplicator',
    title: 'Meta Ads: Campaign Duplicator',
    description: 'Duplicate and update existing campaigns to quickly launch new variations.',
    logo: META_ADS_LOGO,
    message: 'Duplicate and modify my existing Meta Ads campaign',
    agent: 'meta_ads',
    category: 'meta-ads',
  },
  {
    id: 'seo-site-audit',
    title: 'SEO: Site Audit',
    description:
      'Perform comprehensive SEO audits of your website with detailed analysis and recommendations.',
    logo: SEO_LOGO,
    message: 'Perform an SEO audit of my website',
    agent: 'seo',
    category: 'seo',
  },
  {
    id: 'seo-article-writer',
    title: 'SEO: Article Writer & Publisher',
    description: 'Write SEO-optimized articles and publish them automatically to your website.',
    logo: SEO_LOGO,
    message: 'Write and publish an SEO-optimized article for my website',
    agent: 'seo',
    category: 'seo',
  },
  {
    id: 'meta-ads-bulk-creator',
    title: 'Meta Ads: Bulk Creator',
    description: 'Create multiple campaigns, ad variants, and carousel ads in bulk.',
    logo: META_ADS_LOGO,
    message: 'Create multiple Meta Ads campaigns and ad variants in bulk',
    agent: 'meta_ads',
    category: 'meta-ads',
  },
  {
    id: 'seo-bulk-keyword-research',
    title: 'SEO: Bulk Keyword Research',
    description:
      'Research keywords in bulk to discover opportunities and optimize your content strategy.',
    logo: SEO_LOGO,
    message: 'Research keywords in bulk for my SEO strategy',
    agent: 'seo',
    category: 'seo',
  },
  {
    id: 'seo-keyword-research-location',
    title: 'SEO: Keyword Research Per Location',
    description:
      'Conduct location-specific keyword research with detailed reports for each location.',
    logo: SEO_LOGO,
    message: 'Research keywords per location for my SEO strategy',
    agent: 'seo',
    category: 'seo',
  },
  {
    id: 'google-ads-campaign-fetcher',
    title: 'Google Ads: Campaign Fetcher',
    description: 'Retrieve and view all your Google Ads campaigns in one place.',
    logo: GOOGLE_ADS_LOGO,
    message: 'Show me all my Google Ads campaigns',
    agent: 'google_ads',
    category: 'google-ads',
  },
  {
    id: 'meta-ads-pixel-manager',
    title: 'Meta Ads: Pixel Manager',
    description: 'Fetch all pixels and get detailed information on pixel configurations.',
    logo: META_ADS_LOGO,
    message: 'Show me all my Meta Ads pixels and their configurations',
    agent: 'meta_ads',
    category: 'meta-ads',
  },
]
